module.exports = __webpack_public_path__ + "img/pic_3@2x.cef25530.png";